<template>
  <div>
    <div class="block">
      <div class="block-header">
        <h3 class="block-title"><i class="fa fa-briefcase"></i> {{ $t('workplaces.index') }}</h3>
        <div class="block-options">
            <b-btn v-b-modal.addworkplace size="sm" variant="primary" class="float-right">{{ $t('workplaces.add') }}</b-btn>
        </div>
      </div>
        <table class="table table-hover">
          <thead>
            <th>#</th>
            <th>{{ $t('app.name') }}</th>
            <th>{{ $t('workplaces.position') }}</th>
            <th>{{ $t('app.desc') }}</th>
            <th>{{ $t('app.action') }}</th>
          </thead>
          <tbody>
              <tr v-for="(work_place, index) in work_places" v-if="!isProcessing">
                <td>{{index+1}}</td>
                <td v-if="work_place.name != null">{{work_place.name}}</td>
                <td v-if="work_place.name == null">Не определен</td>
                <td v-if="work_place.position != null">{{work_place.position}}</td>
                <td v-if="work_place.position == null">Не определен</td>
                <td>{{work_place.description}}</td>
                <td>
                  <div class="btn-group">
                    <button @click.prevent="initUpdate(index)" class="btn btn-primary btn-sm d-inline">
                      <i class="fa fa-edit"></i>
                    </button>
                    <button @click.prevent="handleDelete(work_place.id)" class="btn btn-danger btn-sm ">
                      <i class="fa fa-times-circle"></i>
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-if="isProcessing">
                <td colspan="6" class="text-center">
                  <div class='sk-wave'>
                    <div class='sk-rect sk-rect-1'></div>
                    <div class='sk-rect sk-rect-2'></div>
                    <div class='sk-rect sk-rect-3'></div>
                    <div class='sk-rect sk-rect-4'></div>
                    <div class='sk-rect sk-rect-5'></div>
                  </div>
                </td>
              </tr>
          </tbody>
        </table>
    </div>

    <b-modal id="addworkplace" size="lg" :title="$t('workplaces.add_title')" ref="modalAddWorkPlace" @ok="handleStore" :ok-title="$t('buttons.ok')" :cancel-title="$t('buttons.cancel')" @ok-disabled="isProcessing">
      <form @submit.stop.prevent="storeWorkPlace">
        <div class="form-group">
          <label for="StoreCompanyName" class="col-form-label">{{ $t('app.name') }}</label>
          <input type="text" class="form-control" v-model="work_place.name" v-bind:class="{'is-invalid': errors.name }" id="StoreCompanyName">
          <span v-if="errors.name" class="invalid-feedback">
              <strong>{{ errors.name ? errors.name[0] : '' }}</strong>
          </span>
        </div>
        <div class="form-group">
          <label for="StorePosition" class="col-form-label">{{ $t('workplaces.position') }}</label>
          <input type="text" class="form-control" v-model="work_place.position" v-bind:class="{'is-invalid': errors.position }" id="StorePosition">
          <span v-if="errors.position" class="invalid-feedback">
              <strong>{{ errors.position ? errors.position[0] : '' }}</strong>
          </span>
        </div>
        <div class="form-group">
          <label for="StoreDesc" class="col-form-label">{{ $t('app.desc') }}</label>
          <textarea class="form-control" v-model="work_place.description" v-bind:class="{'is-invalid': errors.description }" id="StoreDesc" rows="3"></textarea>
          <span v-if="errors.description" class="invalid-feedback">
              <strong>{{ errors.description ? errors.description[0] : '' }}</strong>
          </span>
        </div>
      </form>
    </b-modal>

    <b-modal id="updateworkplace" size="lg" :title="$t('workplaces.edit_title')" ref="modalUpdateWorkPlace" @ok="handleUpdate" @shown="fetchWorkPlaces" :ok-title="$t('buttons.save')" :cancel-title="$t('buttons.cancel')" @ok-disabled="isProcessing">
      <form @submit.stop.prevent="updateWorkPlace">
          <div class="form-group">
            <label for="updateCompanyName" class="col-form-label">{{ $t('app.name') }}</label>
            <input type="text" class="form-control" v-model="update_work_place.name" v-bind:class="{'is-invalid': update_errors.name }" id="updateCompanyName">
            <span v-if="update_errors.name" class="invalid-feedback">
                <strong>{{ update_errors.name ? update_errors.name[0] : '' }}</strong>
            </span>
          </div>
          <div class="form-group">
            <label for="updatePosition" class="col-form-label">{{ $t('workplaces.position') }}</label>
            <input type="text" class="form-control" v-model="update_work_place.position" v-bind:class="{'is-invalid': update_errors.position }" id="updatePosition">
            <span v-if="update_errors.position" class="invalid-feedback">
                <strong>{{ update_errors.position ? update_errors.position[0] : '' }}</strong>
            </span>
          </div>
          <div class="form-group">
            <label for="updateDesc" class="col-form-label">{{ $t('app.desc') }}</label>
            <textarea class="form-control" v-model="update_work_place.description" v-bind:class="{'is-invalid': update_errors.description }" id="updateDesc" rows="3"></textarea>
            <span v-if="update_errors.description" class="invalid-feedback">
                <strong>{{ update_errors.description ? update_errors.description[0] : '' }}</strong>
            </span>
          </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      work_places: [],
      work_place: {
        name: '',
        position: '',
        description: ''
      },
      update_work_place: {},
      errors: [],
      update_errors: [],
      message: '',
      isProcessing: false,
    };
  },
  computed: {
    ...mapGetters([
      'adminDebtor',
    ]),
  },
  mounted() {
    this.fetchWorkPlaces();
  },
  methods: {
    fetchWorkPlaces() {
      this.isProcessing = true;
      window.axios.get(`/admin/debtors/${this.$route.params.id}/workplaces`)
        .then((res) => {
          this.work_places = res.data.work_places;
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    clearModal() {
      this.work_place.name = '';
      this.work_place.position = '';
      this.work_place.description = '';
      this.errors = {};
    },

    clearUpdateModal() {
      this.update_work_place = {};
      this.update_errors = {};
    },

    initUpdate(index) {
      this.update_errors = {};
      this.$refs.modalUpdateWorkPlace.show()
      this.update_work_place = this.work_places[index];
    },

    handleUpdate(evt) {
      evt.preventDefault();
      this.updateWorkPlace();
      this.isProcessing = true;
    },

    handleStore(evt) {
      evt.preventDefault();
      this.storeWorkPlace();
      this.isProcessing = true;
    },

    handleDelete(id) {
      window.Swal.fire({
        title: this.$t('alerts.are_you_sure'),
        text: this.$t('alerts.want_to_delete'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('alerts.delete_it'),
        cancelButtonText: this.$t('field.cancel'),
      }).then((result) => {
        if (result.value) {
          this.deleteWorkPlace(id);
        }
      });
    },

    storeWorkPlace() {
      window.axios.post(`/admin/debtors/workplaces/${this.$route.params.id}`, this.work_place)
        .then((res) => {
          if (res.status === 201) {
            this.$refs.modalAddWorkPlace.hide();
            this.clearModal();
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.fetchWorkPlaces();
          }
        })
        .catch((err) => {
          this.errors = this.laravelValidation(err);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    updateWorkPlace() {
      window.axios.put(`/admin/debtors/workplaces/${this.update_work_place.id}`, this.update_work_place)
        .then((res) => {
          if (res.status === 200) {
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.clearUpdateModal();
            this.$refs.modalUpdateWorkPlace.hide();
            this.fetchWorkPlaces();
          }
        })
        .catch((err) => {
          this.update_errors = this.laravelValidation(err);
        })
        .finally(() => {
          this.isProcessing = false;
        })
    },

    deleteWorkPlace(id) {
      window.axios.delete(`/admin/debtors/workplaces/${id}`)
        .then((res) => {
          if (res.status === 204) {
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.fetchWorkPlaces();
          }
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>
